// extracted by mini-css-extract-plugin
module.exports = {"root":"SqlDataSelect-module__root__UzxI9","category":"SqlDataSelect-module__category__31M4c"};